import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import Clock from 'vue-digital-clock';
import paginate from 'paginate-array';
import * as screenfull from 'screenfull';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

import {
	EventBus
} from '@/support/event-bus';

export default {
	state,
	actions,
	mutations,
	getters,
	name: 'leaving-monitor',
	data: () => ({
		paginateCollection: []
	}),
	components: {
		Clock
	},
	computed: {
		...mapState({
			userId: (state) => state.Logged.user.id
		}),
		...mapGetters({
			students: 'students',
		})
	},
	methods: {
		...mapActions([
			'getLeavingMonitor',
			'postStudentRelease'
		]),
		removeStudentItem(student) {

			this.postStudentRelease(student).then(() => {
				EventBus.$emit('loadMonitor');
			});

		},
		fullscreen() {

			if (screenfull.enabled) {
				screenfull.toggle();
			}

		},
		loadMonitor() {

			let currentPage = 1;

			this.getLeavingMonitor(this.userId).then(() => {

				this.paginateCollection = paginate(this.students, currentPage);

			}).then(() => {

				setInterval(() => {
					currentPage++;
					if (this.paginateCollection.totaPages >= currentPage) {
						this.paginateCollection = paginate(this.students, currentPage);
					}
					if (this.paginateCollection.totaPages + 1 === currentPage) {
						currentPage = 0;
					}
				}, 10000);

			});
		}
	},
	mounted() {

		this.loadMonitor();

		EventBus.$on('loadMonitor', () => {
			this.loadMonitor();
		});

		setInterval(() => {
			EventBus.$emit('loadMonitor');
		}, 1000 * 40);
	},
	beforeDestroy() {

		EventBus.$off('loadMonitor');

	}
};



// WEBPACK FOOTER //
// ./sources/app/leaving-monitor/index.js